import { commonjsGlobal as o } from "./index135.mjs";
var e = typeof o == "object" && o && o.Object === Object && o, a = e;
export {
  a as _
};
